import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconControllerButtonTriangle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconControllerButtonTriangle"><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Path d="M10.9251 8.25505C11.4168 7.4522 12.5832 7.4522 13.0749 8.25505L16.3249 13.5618C16.8393 14.4017 16.2349 15.4805 15.2501 15.4805H8.74995C7.7651 15.4805 7.16073 14.4017 7.67509 13.5618L10.9251 8.25505Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconControllerButtonTriangle;
